<template>
    <NotificationAlert
        class="w-full"
        :subtitle="$t('shared.invalid.some_form_fields')"
        :closeButton="false"
    />
</template>

<script>
import { NotificationAlert } from "@easy/ui/notifications";

export default {
    components: {
        NotificationAlert,
    },
};
</script>
